export default [
    {
        path: '/teacherWorkRegimeRules',
        name: 'teacherWorkRegimeRules',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Regras de Regime de Trabalho',
            icon: '',
            breadcrumbs: [
                { text: 'Instituição', disabled: true, href: '/' },
                { text: 'Regras de Regime de Trabalho', disabled: true, href: '/' },
            ],
        }
    },
]
